<template>
	<span>
		{{ displayText }}
	<modal inlineBlock v-model="isOpen" container-style="max-width: 100%; width: 400px;" :container-style="mq.current >= mq.md ? '' : 'top:20px'" :rootClass="'delivery-notice'">
		<span slot="label" v-if="infoText">
			<span v-if="infoText" class="glyphicon glyphicon-info-sign help" @click.prevent.stop="isOpen = true" :title="infoText"/>
		</span>
		<div class="delivery-notice">
			<b><p>
				{{ tp('LONG_DELIVERY_TIME_SHORT') }}
			</p></b>
			<p>
			{{ infoText }}
		</p>
	</div>
	</modal>
</span>
</template>

<script>
import mq from 'mediaQuery';
import { t } from 'datastore/i18n';

export default {
	data () {
		return {
			mq,
			isOpen: false,
			tp: t.prefix('PRODUCT'),
		};
	},
	props: {
		displayText: {
			type: String,
			required: true,
		},
		infoText: {
			type: String,
			default: '',
		}
	}
};
</script>
